export default __webpack_public_path__ + "email-a-friend.png";